export class BreadCrumbItem {
  name: string | undefined;
  path: string | undefined;
  translated: boolean | undefined;

  constructor(name: string | undefined, path: string | undefined, translated: boolean | undefined) {
    this.name = name;
    this.path = path;
    this.translated = translated;
  }
}

export const   HOME_BREADCRUMB_ITEM = new BreadCrumbItem("page.home", "/", true);
export const   FEATURED_ARTICLE_BREADCRUMB_ITEM = new BreadCrumbItem("page.featured-article", undefined, true);
export const   MOST_READ_BREADCRUMB_ITEM = new BreadCrumbItem("page.most-read", undefined, true);
export const   ONINE_FIRST_BREADCRUMB_ITEM = new BreadCrumbItem("page.online-first", undefined, true);
export const   ONINE_FIRST_LINK_BREADCRUMB_ITEM = new BreadCrumbItem("page.online-first", "/online-first", true);
export const   NEWS_ITEMS_BREADCRUMB_ITEM = new BreadCrumbItem("page.news", undefined, true);
export const   NEWS_ITEMS_LINK_BREADCRUMB_ITEM = new BreadCrumbItem("page.news", "/news", true);
export const   ISSUES_BREADCRUMB_ITEM = new BreadCrumbItem("page.issues", undefined, true);
export const   ISSUES_LINK_BREADCRUMB_ITEM = new BreadCrumbItem("page.issues", "/issues", true);
export const   SEARCH_BREADCRUMB_ITEM = new BreadCrumbItem("page.search", undefined, true);

export const   USER_BREADCRUMB_ITEM = new BreadCrumbItem("page.user", undefined, true);
export const   PAYMENYT_ITEM = new BreadCrumbItem("page.payment", undefined, true);


